type SetView = (view: "items" | "information") => void;

export const showItemsHelper = (setView: SetView) => () => {
    setView("items");
    if (typeof window !== "undefined") {
        history.replaceState(null, "", window.location.pathname + window.location.search);
    }
};

export const showInformationHelper = (setView: SetView) => () => {
    setView("information");
    if (typeof window !== "undefined") {
        history.replaceState(null, "", window.location.pathname + window.location.search);
    }
};